import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";

interface CreatePositionProps extends ButtonProps {}

export const CreatePosition = (props: CreatePositionProps) => {
  return (
    <Button
      {...props}
      iconProps={{
        name: "plus-solid",
        title: "plus-solid"
      }}
      modifier="secondary"
      type="button"
    >
      {appstr("Create position")}
    </Button>
  );
};
